import React from "react"
import { Radio } from "antd"
import PropTypes from "prop-types"
import Box from "../../lib/ui/ui-box"

const RadioButton = Radio.Button
const RadioGroup = Radio.Group

const renderRadioGroup = props => (
  <RadioGroup defaultValue="a" size="large" {...props} {...props.input}>
    <Box flexDirection="row" wrap="wrap">
      {props.choices.map(({ label, value }, index) => {
        return (
          <Box mb={[1]} mr={[1]} key={`label-${index}`}>
            <RadioButton value={value}>{label}</RadioButton>
          </Box>
        )
      })}
    </Box>
  </RadioGroup>
)

renderRadioGroup.propTypes = {
  choices: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })
  )
}

export default renderRadioGroup



// WEBPACK FOOTER //
// ./src/components/render-radio-group/render-radio-group.component.js